import { Event } from '../_base/eventBus/EventBus';

export class PaymentInformed implements Event {}
